import { CompatibilityService, IDeferred } from "../services/compatibilityservice";
import { fn } from "@common/utils";
import { ValidateCompany } from "@common/rwf/rwfuserinteraction";

/** Display Companies for Url and Allow user to select one */
export class CtrlSelectCompany {

    static ModalSelectCompany($c: CompatibilityService,
        Companies: PromiseLike<string[]> | string[],
        validateCompany?: ValidateCompany): PromiseLike<string> {
        let dlgWindow: kendo.ui.Window;
        let ctrl: CtrlSelectCompany;
        let result = $c.defer<string>();
        return $c.resolve("DialogService").ShowWindow({
            windowOptions: {
                title: "Mandant wählen",
                width: "350px"
            },
            controller: CtrlSelectCompany,
            controllerAs: "vm",
            resolve: {
                "Companies": [() => Companies],
                "ValidateCompany": [() => (company) => {
                    return $c.when(validateCompany && validateCompany({ Company: company, StoreAsDefault: ctrl.RememberSelection })).then(() => {
                        result.resolve(company);
                        dlgWindow.close();
                    });
                }],
                "AllowStoreAsDefault": [() => true]
            },
            template: require('./SelectCompany.html')
        }).then(dlg => {
            ctrl = <CtrlSelectCompany>dlg.controller;
            dlgWindow = dlg.window;
            dlg.close.then(() => {
                try {
                    fn.error.ThrowCancel();
                } catch (err) {
                    result.reject(err);
                }
            });
            return ctrl.CompanySelected.promise;
        });
    }

    static $inject = ["CompatibilityService", "Companies", "ValidateCompany", "AllowStoreAsDefault"];
    constructor(
        readonly $c: CompatibilityService,
        Companies: PromiseLike<string[]>,
        readonly ValidateCompany: (company: string) => any | PromiseLike<any>,
        readonly AllowStoreAsDefault: boolean
    ) {
        // this.Store = AllowStoreAsDefault;
        this.CompanySelected = $c.defer();
        this.InValidate = true;
        $c.when(Companies).then(companies => {
            this.Companies = companies;
            this.InValidate = false;
        }, err => {
            this.CompanySelected.reject(err);
            throw err;
        });
    }

    public SelectCompany(company: string) {
        const $c = this.$c;
        if (company) {
            this.SelectedCompany = company;
            this.InValidate = true;
            this.CurrentError = "";
            try {
                $c.when(this.ValidateCompany(company)).then(s => {
                    this.CompanySelected.resolve(this.SelectedCompany = company);
                }, err => {
                    this.CurrentError = fn.resolveToError(err);
                    delete this.SelectedCompany;
                    this.InValidate = false;
                });
            } catch (err) {
                this.CurrentError = fn.resolveToError(err);
            }
        }
    }

    InValidate = false;
    RememberSelection = false;
    Companies: string[];
    SelectedCompany = "";
    CurrentError = "";

    readonly CompanySelected: IDeferred<string>;
}
